import { render } from "./Preload.vue?vue&type=template&id=487b07c6"
import script from "./Preload.vue?vue&type=script&lang=js"
export * from "./Preload.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__